export default [
  {
    path: '/record/:chapterId/:resourceId/:openCourseId/:vid/:type/:duration',
    name: 'record',
    meta: {
      title: '视频播放',
      requireAuth: true,
    },
    component: () => import(/* webpackChunkName: "learn" */ '@/pages/video/record.vue'),
  },
  {
    path: '/audition',
    name: 'audition',
    meta: {
      title: '试听',
    },
    // eslint-disable-next-line import/extensions
    component: () => import('@/pages/video/Audition'),
  },
];
